webpackJsonp([16228548823048030000],{

/***/ "./src/app/utils.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getClassName = exports.getClassName = function getClassName(prefix) {
	  if (typeof window !== 'undefined' && window.location && window.location.pathname) {
	    if (window.location.pathname === '/education') {
	      return ' ' + prefix + '--education';
	    } else if (window.location.pathname === '/work-experience') {
	      return ' ' + prefix + '--work-experience';
	    } else if (window.location.pathname === '/skills') {
	      return ' ' + prefix + '--skills';
	    } else if (window.location.pathname === '/about') {
	      return ' ' + prefix + '--about';
	    } else {
	      return '';
	    }
	  }
	
	  return '';
	};

/***/ }),

/***/ "./src/assets/images/mark-gaucher.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mark-gaucher.dd7f54e0.jpg";

/***/ }),

/***/ "./src/components/Logo.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _utils = __webpack_require__("./src/app/utils.js");
	
	__webpack_require__("./src/components/Logo.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global window */
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'logo' + (0, _utils.getClassName)('logo') },
	    _react2.default.createElement(
	      'span',
	      { className: 'logo__circle' },
	      _react2.default.createElement(
	        'span',
	        { className: 'logo__name' },
	        'MARK GAUCHER'
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'logo__name' },
	      'MARK GAUCHER'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'logo__description' },
	      'Full Stack Developer'
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Logo.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/Page.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/components/Page.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page(_ref) {
	  var children = _ref.children,
	      type = _ref.type;
	
	  var classNames = 'page';
	  if (type) {
	    classNames += ' page--' + type;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames },
	    children
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Page.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/Profile.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Logo = __webpack_require__("./src/components/Logo.jsx");
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	__webpack_require__("./src/components/Profile.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Profile = function Profile(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'aside',
	    { className: 'profile component-transition' },
	    _react2.default.createElement(
	      'div',
	      { className: 'profile__content' },
	      children
	    )
	  );
	};
	
	exports.default = Profile;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Profile.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/icons/Github.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/components/icons/icon.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = function Github() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      'aria-labelledby': 'title',
	      role: 'img',
	      viewBox: '0 0 24 24',
	      xmlns: 'http://www.w3.org/2000/svg',
	      fillRule: 'evenodd',
	      clipRule: 'evenodd',
	      strokeLinejoin: 'round',
	      strokeMiterlimit: '1.414',
	      className: 'icon'
	    },
	    _react2.default.createElement('path', { d: 'M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12' })
	  );
	};
	
	exports.default = Github;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/icons/LinkedIn.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/components/icons/icon.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkedIn = function LinkedIn() {
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24', className: 'icon' },
	    _react2.default.createElement('path', { d: 'M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z' })
	  );
	};
	
	exports.default = LinkedIn;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/icons/Twitter.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./src/components/icons/icon.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = function Twitter() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      viewBox: '0 0 16 16',
	      xmlns: 'http://www.w3.org/2000/svg',
	      fillRule: 'evenodd',
	      clipRule: 'evenodd',
	      strokeLinejoin: 'round',
	      strokeMiterlimit: '1.414',
	      className: 'icon'
	    },
	    _react2.default.createElement('path', {
	      d: 'M16 3.038c-.59.26-1.22.437-1.885.517.677-.407 1.198-1.05 1.443-1.816-.634.37-1.337.64-2.085.79-.598-.64-1.45-1.04-2.396-1.04-1.812 0-3.282 1.47-3.282 3.28 0 .26.03.51.085.75-2.728-.13-5.147-1.44-6.766-3.42C.83 2.58.67 3.14.67 3.75c0 1.14.58 2.143 1.46 2.732-.538-.017-1.045-.165-1.487-.41v.04c0 1.59 1.13 2.918 2.633 3.22-.276.074-.566.114-.865.114-.21 0-.41-.02-.61-.058.42 1.304 1.63 2.253 3.07 2.28-1.12.88-2.54 1.404-4.07 1.404-.26 0-.52-.015-.78-.045 1.46.93 3.18 1.474 5.04 1.474 6.04 0 9.34-5 9.34-9.33 0-.14 0-.28-.01-.42.64-.46 1.2-1.04 1.64-1.7z',
	      fillRule: 'nonzero'
	    })
	  );
	};
	
	exports.default = Twitter;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/icons/icon.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/mark/Sites/Personal/markgaucher/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-env/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/about.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Page = __webpack_require__("./src/components/Page.jsx");
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Profile = __webpack_require__("./src/components/Profile.jsx");
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Github = __webpack_require__("./src/components/icons/Github.jsx");
	
	var _Github2 = _interopRequireDefault(_Github);
	
	var _LinkedIn = __webpack_require__("./src/components/icons/LinkedIn.jsx");
	
	var _LinkedIn2 = _interopRequireDefault(_LinkedIn);
	
	var _Twitter = __webpack_require__("./src/components/icons/Twitter.jsx");
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(
	      _Profile2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-x grid-margin-x' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cell shrink' },
	          _react2.default.createElement('img', {
	            src: __webpack_require__("./src/assets/images/mark-gaucher.jpg"),
	            alt: '',
	            className: 'profile__photo'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cell auto' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Mark Gaucher'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:hello@markgaucher.com' },
	              'hello@markgaucher.com'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Husband, puppy daddy, beer drinker. Senior developer at @normativedesign.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-about-js-a9344b7d368f3c6cbb83.js